export default __webpack_public_path__ + "static/media/back.e00d7d65.png";